/**
 * Monta o texto "PDV - Empreendimento" para exibição na linha do tempo da tarefa.
 * Se faltar um dos dois, retorna apenas o que existir. Se faltarem ambos, retorna "--".
 */
export const montarPdvEmpreendimento = (
  nomePdv: string | undefined | null,
  nomeEmpreendimento: string | undefined | null
): string => {
  const partes = [nomePdv, nomeEmpreendimento].filter(
    (parte) => !!parte && parte.trim().length > 0
  );
  return partes.length > 0 ? partes.join(" - ") : "--";
};
